import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import * as turf from '@turf/turf';
import * as L from 'leaflet';
import 'leaflet.vectorgrid';
import 'src/assets/leaflet-geojson-tilelayer/TileLayer.GeoJSON.js';
import 'src/assets/leaflet-image-transform/L.ImageTransform.js';
import 'src/assets/leaflet-spin/leaflet.spin.js';
import 'src/assets/leaflet-spin/leaflet.spin.min.js';
import 'src/assets/leaflet-velocity-src/js/L.CanvasLayer.js';
import 'src/assets/leaflet-velocity-src/js/L.Control.Velocity.js';
import 'src/assets/leaflet-velocity-src/js/L.VelocityLayer.js';
import 'src/assets/leaflet-velocity-src/js/windy.js';
import 'src/assets/map-control/L.Control.ZoomBar.js';

import { Chartconstant } from 'src/app/utils/chart.constant';
import { MapConstants } from 'src/app/utils/map.constant';
import { MapService } from 'src/app/utils/map.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

import { DrinkingWaterDataService } from '../../side-bar/drinking-water-stress/drinking-water-data.service';
import { DrinkingWaterMapConstants } from '../../side-bar/drinking-water-stress/drinking-water-gis/drinking-water.constant';

@Component({
  selector: 'app-gis-map-widget',
  templateUrl: './gis-map-widget.component.html',
  styleUrls: ['./gis-map-widget.component.scss']
})
export class GisMapWidgetComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() layerList: any;
  @Input() otherOptions: any;
  @Input() basinGeoJSONData: any;
  @Input() giscolorsdata: any;
  @Input() legenddata: any;
  @Input() gistest: any;
  @Input() colorsData: any;
  @Input() mapId = 'map';

  map: L.Map;
  geoJsonData: any;
  context: CanvasRenderingContext2D;
  tsArrayForPlay: any = [];
  tsLabelsArrayForPlay: any = [];
  direction: any;
  state = 'stop';
  popUpData: any = {};
  postData: any;
  bottomBarData: any;
  bottomBarColumns: any = [];
  velocityLayer;
  wmsLayerGroup;
  allLayerList: any = [];
  overlayLayerList: any = [];
  geojsonLayerList: any = [];
  wmsLayerList: any = [];
  wmsUrl: any;
  wmsLayer: any;
  value: any = 3;
  imageUrl: any;
  adminSelected: any;
  ruralUrbanSelected: any;
  forecastLength: any;
  shortLongRange: any;
  imageBounds: any = [];
  playpause: boolean;
  startIndex = 1;
  imageLayer: any;
  showThrobber = true;
  bottomBarMenuSelectedIndex;
  styleObjforBottomBar = {};
  vectorTileLayer = {};
  labelStrings = [];
  marker = null;
  noData = false;
  blocks: any;
  Linechart: any;
  millisInSixHours = ProjConstants.MILLIS_IN_6HOURS;
  showBottomBar: any;
  districtClicked: object;
  particleMultiplier: any = 0.0006;
  showThrobberbottomBar = false;
  abbrvMapping = ProjConstants.COMPONENT_ABBREVIATION_MAPPING;
  heatMapoptions = {
    opacity: 0.8,
    pane: 'heatMap',
    minZoom: 6,
    maxZoom: 15
  };
  borderBottomBarStyle = {};
  // timestamp:;
  colorForBottomBar: any;
  nowForPlay: any;
  bottomBarDataWithStyle: any;
  bottomBarTableStyles: any = {};
  gradientColors: any = [];
  gradientStyles: any = {};
  heightHundred: any = {};
  gradient: any;
  blockLayer: any;
  customMarker = new L.icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Map_marker_font_awesome.svg',
    iconSize: [35, 41],
    iconAnchor: [14, 41],
    popupAnchor: [15, -40]
  });
  yAxisMin: any;
  chartTableData: any;
  chartGradient: any;
  dateList: any;
  clickedLocationMarker: any;
  clickedLocationTooltip: any;
  bottomTableKeys: any = [];
  playWidth: any = 3;
  stateBoundary: any;
  basinBoundary: any;
  activeTimePeriod: any;

  districtClickedSubscription: any;
  adminBasinSubscription: any;
  ruralUrbanSubscription: any;
  forecastLengthSubscription: any;
  toggleSubscription: any;
  timeStampList: {};
  revalidateMapSubscription: any;
  selectedLocation: any;
  dataTabToggleVal = false;
  activeLayers: any = [];
  view: string;
  activeGroup: any;
  leftSideBarSubscription: any;
  apiData: any;
  type: string;
  apiParams: any;
  minMax: any;
  STATENAME: any;
  serviceMap: any;
  urlParams: any;
  bottomBarComponent: any;
  legend: any;
  thresholdMap: object;
  initialCounter: number;
  counter: number;
  style = {
    stroke: false,
    color: '#FF0000',
    fill: true,
    fillColor: '#FF0000',
    fillOpacity: 0.4,
    opacity: 0.4
  };
  componentType: string;
  hourCounter = '';
  blockNumber = 0;
  dateBlockNumMap = {};
  playPosition = 0;
  collapsebutton: any;
  activeSideMenu: any;
  polygons = [];
  bottombarClick: boolean;
  meanMedian: string;
  showOption = false;
  selectedOption: any;
  application: string;
  villageLayerSubscription: any;
  villageLayer: any;
  rUview: string;
  MLayerGrp: any;
  mapLayerGroup: any;
  ulbNameLayer = new (L as any).layerGroup();
  isallUlbsAdded = false;

  isUlbMarkerClicked = false;
  forNames = [];
  ulbLayer: any;
  UrbanLayerSubscription: any;
  ulbCentroidData: any;
  allUlbLayer: any;
  allUlbNames = new (L as any).layerGroup();
  stateId = 'akbm';
  htmlLegend: any;

  constructor(
    public DWSDataService: DrinkingWaterDataService,
    private utils: UtilsService,
    public mapService: MapService,
    public chartConstant: Chartconstant,
    private injector: Injector,
    public datepipe: DatePipe  ) {
    // const stateUrlId = this.route.snapshot.paramMap.get('id');
    const stateUrlId = this.stateId;
    this.STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[stateUrlId];
    this.setLocationData();
    this.selectedLocation = '';
    this.showThrobber = true;
    this.postData = {};
    this.geoJsonData = {};
    this.dateList = [];
    this.utils.getAdminBasinToggle().subscribe(
      () => {
        this.view = 'Admin';
      }
    ).unsubscribe();
    this.utils.minMax.subscribe(value => {
      this.minMax = value;
    }).unsubscribe();
    // this.forecastLength = this.route.snapshot.paramMap.get('time');
    this.forecastLength = '10';
    // this.selectedComponent = router.url.split('/')[1];
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initMap();
      // TODO: Can be uncommented if required
      // this.addBaseLayers(this.layerList);
      // this.serviceMap.addTimeBasedLayers(this, this.layerList);

      this.addSubscriptions();
      this.direction = {};
      return;
    }, 100);
  }

  ngOnInit() { }

  ngOnDestroy() {
    if (!isNullOrUndefined(this.forecastLengthSubscription)) {
      this.forecastLengthSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.adminBasinSubscription)) {
      this.adminBasinSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.districtClickedSubscription)) {
      this.districtClickedSubscription.unsubscribe();
    }
    this.setInitial();
    if (!isNullOrUndefined(this.villageLayerSubscription)) {
      this.villageLayerSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.leftSideBarSubscription)) {
      this.leftSideBarSubscription.unsubscribe();
    }
  }

  ngOnChanges(change: SimpleChanges) {
    if (this.map && this.otherOptions.reloadAllTimeLayers) {
      this.reloadAllTimeLayers();
    }
    if (this.map && this.otherOptions.addInverseMask) {
      this.serviceMap.removeAndAddInverseMask(this, this.otherOptions.inverseData);
    }
    if (this.basinGeoJSONData) {
      this.createMultiPolygon(this.basinGeoJSONData);
    }
    if (change.giscolorsdata && change.giscolorsdata.currentValue) {
      // this.removeAllLayers();
      this.addBaseLayers(this.layerList);
    }
    if (change.colorsData && change.colorsData.currentValue) {
      // this.removeAllLayers();
      this.addBaseLayers(this.layerList);
    }
    if (change.legenddata && change.legenddata.currentValue) {
      this.addLegend();
    }
    // TODO: implement if souce chage (IMD/ECMWF)
    // if (change.sourceSelected && change.sourceSelected.currentValue) {
    //   this.changeAttribution();
    // }

    // if(change.layerList && change.layerList.currentValue){
    //   this.labelStrings = [];
    //   this.removeAllTimeLayers();
    //   this.serviceMap.addTimeBasedLayers(this, this.layerList);
    // }
  }

  initMap(): void {
    if (this.map) {
      this.map.remove();
    }
    this.map = new L.Map(this.mapId, this.mapService.getWidgetMapOptions(this.STATENAME, ProjConstants));
    this.injectService();
    this.createPanes();
    // this.addLegend();
    this.addMapEvents();
    this.setUrlParams();
  }


  createPanes() {
    MapConstants.PANE_LIST.forEach(pane => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  setInitial() {
    const district = {
      locType: 'State',
      loc: this.STATENAME,
      centroid: ProjConstants[this.STATENAME + '_CENTER'],
      zoomLevel: ProjConstants[this.STATENAME + '_ZOOM_LEVEL']
    };
    this.utils.districtClicked.next(district);
  }

  public setUrlParams() {
    if (this.otherOptions['urlParams']) {
      this.urlParams = this.otherOptions['urlParams'];
    }
  }

  public injectService() {
    this.serviceMap = this.injector.get<any>(this.otherOptions['service']);
  }

  public addMapEvents() {
    this.map.on({
      zoomstart: () => {
        {
          if (this.clickedLocationMarker != null && this.clickedLocationMarker != undefined) {
            this.clickedLocationMarker.unbindTooltip();
            this.clickedLocationMarker.bindTooltip(this.clickedLocationTooltip);
            this.clickedLocationMarker = null;
          }
        }
      }
    });
  }

  addSubscriptions() {
    this.adminBasinSubscription = this.utils.getAdminBasinToggle().subscribe(value => {
      if (this.adminSelected != value) {
        this.adminSelected = value;
        if (this.adminSelected == true) {
          this.view = 'Admin';
        } else {
          this.view = 'Basin';
        }
        this.removeAllLayers();
        this.addBaseLayers(this.layerList);
        this.serviceMap.addTimeBasedLayers(this, this.layerList);
      }
    });

    // this.districtClickedSubscription = this.utils.districtClicked.subscribe(value => {
    //   this.districtClicked = value;
    //   let blockLayer = null;
    //   for (const i in this.activeLayers) {
    //     if (!this.activeLayers) {
    //       const layer = this.activeLayers[i];
    //       if (!isNullOrUndefined(layer['name']) && layer['name'] == 'blockLayer') {
    //         blockLayer = layer['layer'];
    //       }
    //     }
    //   }
    //   if (this.districtClicked == null) {
    //     if (this.map.getZoom() < 9) {
    //       this.map.removeLayer(blockLayer);
    //       blockLayer.options.minZoom = 9;
    //       blockLayer.addTo(this.map);
    //     }
    //     return;
    //   }
    //   if (this.districtClicked['loc'] == undefined) {
    //     return;
    //   }
    //   let latLong: any;
    //   let zoomLevel: any;
    //   console.log('district clicked', this.districtClicked);
    //   if (this.districtClicked['locType'] == 'State') {
    //     latLong = this.districtClicked['centroid'];
    //     zoomLevel = this.districtClicked['zoomLevel'];
    //     if (this.map.getZoom() < 9) {
    //       if (this.map.hasLayer(blockLayer)) {
    //         this.map.removeLayer(blockLayer);
    //       }
    //       if (!isNullOrUndefined(blockLayer)) {
    //         blockLayer.options.minZoom = 9;
    //         blockLayer.addTo(this.map);
    //       }
    //     }
    //   } else if (this.adminSelected) {
    //     // latLong = MapConstants[ProjConstants.STATENAME+'_DISTRICT_CENTERS'][this.districtClicked['loc'].toUpperCase()]
    //     latLong = [this.districtClicked['centroid']['lat'], this.districtClicked['centroid']['lon']];
    //     zoomLevel = 10;
    //     if (ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked['locType']] != undefined) {
    //       zoomLevel = ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked['locType']];
    //     }

    //   } else {
    //     // latLong = MapConstants[ProjConstants.STATENAME+'_BASIN_CENTERS'][this.districtClicked['loc'].toUpperCase()][0]
    //     latLong = [this.districtClicked['centroid']['lat'], this.districtClicked['centroid']['lon']];
    //     zoomLevel = 9;
    //     if (ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked['locType']] != undefined) {
    //       zoomLevel = ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked['locType']];
    //     }
    //     if (this.districtClicked['locType'] == 'Basin' && MapConstants[ProjConstants.STATENAME + '_BASIN_CENTERS'][this.districtClicked['loc'].toUpperCase()] != undefined) {
    //       zoomLevel = MapConstants[ProjConstants.STATENAME + '_BASIN_CENTERS'][this.districtClicked['loc'].toUpperCase()][1];
    //     }
    //     blockLayer.options.minZoom = zoomLevel;
    //     this.map.removeLayer(blockLayer);
    //     blockLayer.addTo(this.map);
    //   }
    //   if (this.districtClicked['locType'] == 'ULB') {
    //     this.map.flyTo(latLong, zoomLevel);
    //   } else {
    //     this.map.setView(latLong, zoomLevel);
    //   }
    // });
  }

  addLegend() {
    let data = this.legenddata ? this.legenddata : this.otherOptions.legend;
    if (this.forecastLength === 'weekly') {
      data = this.otherOptions.weeklyLegend;
    }
    // function for legend styling
    if (this.legend) {
      this.legend.remove();
    }

    const legend = L.control({ position: 'bottomright' });
    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info');
      div.style = 'max-height: 500px; overflow-y: auto;';
      if (data != null && data != undefined) {
        if (data.Units != undefined && data.Units != null) {
          div.innerHTML += '<p class="bg-white font-weight-bold text-dark text-center my-0">'
            + data.Units + '</p';
        }
        const ranges = data.colorValues;
        for (let i = ranges.length - 1; i >= 0; i--) {
          div.innerHTML +=
            '<p class="my-0 font-weight-bold text-center" style="background-color:' + ranges[i]['backgroundColor'] + ' ; color:' + ranges[i]['color'] + '">' + ranges[i].text + '</p>';
        }
      }
      return div;
    };
    this.legend = legend;

    legend.addTo(this.map);
  }

  addBaseLayers(layerList) {
    for (const index in layerList) {
      const layer = layerList[index];
      if (layer['type'] == 'Base' && (layer['view'] == this.view || layer['view'] == 'Both')) {
        const layerObj = this.serviceMap.createLayer(layer, this);
        if (layerObj['layer'] != undefined && layerObj['layer'] != null) {
          layer['hidelayer'] == true ? (layer['hidelayer'] == false || !layer['hidelayer']) : layerObj['layer'].addTo(this.map);
          this.activeLayers = this.activeLayers.concat(layerObj);
        }
        layerList[index] = layerObj;
        if (this.giscolorsdata && (layerObj.layerName == 'ANDHRA PRADESH_STATE_BLOCK' || layerObj.layerName == 'forecast:ANDHRA PRADESH_STATE_BLOCK')) {
          this.serviceMap.fillMapWithColors(this.giscolorsdata, layerObj);
        }
        if (this.gistest && layerObj.layerName == 'ANDHRA PRADESH_STATE_BLOCK' && this.rUview == 'Rural') {
          this.serviceMap.fillMapColorForDWStress(this.colorsData, layerObj, this);
        }
      }
    }
    this.layerList = layerList;
  }

  addZoomBar() {
    const zoomBarControl = new (L as any).control.zoomBar();
    zoomBarControl.addTo(this.map);
  }

  revalidateMap(): void {
    window.dispatchEvent(new Event('resize'));
    if (this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200);
    }

  }

  removeGroupTimeLayers(groupName) {
    this.serviceMap.removeGroupTimeLayers(this, groupName);
  }

  removeAllTimeLayers() {
    this.serviceMap.removeAllTimeLayers(this);
  }

  removeAllLayers() {
    for (const index in this.activeLayers) {
      const layer = this.activeLayers[index];
      if (layer != undefined && layer['layer'] != undefined && layer['layer'] != null) {
        this.map.removeLayer(layer['layer']);
      }
      this.activeLayers[index] = 'deleted';
    }
    this.activeLayers = this.activeLayers.filter(item => item != 'deleted');
    this.map.eachLayer((layer: any) => this.map.removeLayer(layer));
  }

  closeBottomBar() {
    if (this.map.hasLayer(this.clickedLocationMarker)) {
      this.clickedLocationMarker.unbindTooltip();
      this.clickedLocationMarker.bindTooltip(this.clickedLocationTooltip);
      this.clickedLocationMarker = null;
    }
    if (this.map.hasLayer(this.marker)) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }
    this.showBottomBar = false;
  }

  setLocationData() {
    this.utils.getLocationLayerData((data) => {
      if (data.features && data.features.length == 1 && data.features[0].properties && data.features[0].properties.block && data.features[0].properties.state_name == this.STATENAME) {
        this.selectedLocation = data.features[0].properties.block;
      } else {
        // this.selectedLocation = ProjConstants.IDTOLOCATIONMAPPING[this.route.snapshot.paramMap.get('id')];
        this.selectedLocation = ProjConstants.IDTOLOCATIONMAPPING[this.stateId];
      }
    }, (error) => {
      console.log(error);
      // this.selectedLocation = ProjConstants.IDTOLOCATIONMAPPING[this.route.snapshot.paramMap.get('id')];
      this.selectedLocation = ProjConstants.IDTOLOCATIONMAPPING[this.stateId];
    }, 'INDIA_BLOCK');
  }

  collapse(event: any) {
    this.collapsebutton = event;
  }

  activeMenu(event: any) {
    this.activeSideMenu = event;
  }

  createMultiPolygon(data: any) {
    let polyCoords = [];
    data.features.forEach((element: any) => {
      element.geometry.coordinates.forEach(el => {
        el.forEach(elm => {
          polyCoords = [];
          elm.forEach(elmnt => {
            polyCoords.push(elmnt);
          });
          const poly = turf.polygon([polyCoords]);
          this.polygons.push(poly);
        });
      });
    });
  }

  checkIfPointInsidePolygon(latlng: any) {
    if (this.polygons.length > 0) {
      const point = turf.point([latlng.lng, latlng.lat]);
      let counter = 0;
      this.polygons.forEach(poly => {
        if (turf.inside(point, poly)) {
          counter = 1;
        }
      });
      if (counter !== 1) {
        this.bottombarClick = false;
        this.closeBottomBar();
        alert('No data present for the point');
        return false;
      }
    }
    return true;
  }

  reloadAllTimeLayers() {
    this.showThrobber = true;
    this.removeAllTimeLayers();
    this.serviceMap.addTimeBasedLayers(this, this.layerList);
    // this.addLegend();
  }

}
